<template>
  <div class="teacher">
    <div class="innerBox">
      <div class="close" @click="close">
        <img src="../assets/close.png" />
      </div>
      <div class="title">
        <span>{{title}}</span>
      </div>

      <div class="codeBox">
        <img :src="code" alt />
        <!-- <img v-if="title == '关注公众号'" :src="code" alt />
        <div v-else id="qrcode" ref='qrcode'></div> -->
      </div>
      <div class="content">
        <span>{{content}}</span>
      </div>
    </div>
  </div>
</template>

<script>
// import QRCode from 'qrcodejs2'

export default {
  data() {
    return {
      // code: "",
    };
  },
  props: {
    title: String,
    content: String,
    code: String
  },
  methods: {
    close() {
      this.$emit("close", false);
    }
  },
  mounted() {

  },
  watch:{
    code (value){
      // if(this.title !== '关注公众号'){
      //   console.log(value)
      //   let qrcode = new QRCode('qrcode', {
      //     width: 150,
      //     height: 150,
      //     text: value, // 二维码地址
      //     colorDark : "#000",
      //     colorLight : "#fff"
      //   })
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin wh($w: 100%, $h: 100%) {
  width: $w;
  height: $h;
}
@mixin flexCenter() {
  display: flex;
  align-items: center;
  justify-content: center;
}
@mixin flexColumn() {
  display: flex;
  flex-direction: column;
}
@mixin marginAuto() {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.teacher {
  @include wh();
  position: absolute;
  background-color: rgba(#000000, 0.7);
  left: 0;
  top: 0;
  z-index: 9999;
}
.innerBox {
  @include wh(527px, 420px);
  @include marginAuto();
  @include flexColumn();
  min-width: 700px;
  border-radius: 30px;
  background-color: #fff;
  padding: 15px 25px;
  box-sizing: border-box;
  align-items: center;
  background-image: url("../assets/teacher_public.png");
  background-position: left bottom;
  background-size: cover;
}
.close {
  @include wh(94px, 94px);
  position: absolute;
  top: -47px;
  right: -50px;
  cursor: pointer;
  transition: all 0.5s ease;
  /* &:hover {
    transform: rotate(180deg);
  } */
  img {
    @include wh();
  }
}
.title {
  @include wh(100%, 60px);
  @include flexCenter();
  span {
    font-size: 28px;
    color: #fda90a;
  }
}
.content {
  @include wh(100%, 60px);
  text-align: center;
  line-height: 60px;
  span {
    font-size: 14px;
    text-decoration: underline;
    color: #5e5e5e;
  }
}
.codeBox {
  @include flexColumn();
  padding: 20px;
  align-items: center;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0px 0px 13px 0px rgba(255, 156, 6, 0.5);
  margin-top: 15px;
  img {
    @include wh(150px, 150px);
  }
  span {
    width: 150px;
    text-align: center;
    color: #5e5e5e;
    font-size: 13px;
  }
}
.info {
  height: 200px;
  line-height: 200px;
}
</style>
